import { render, staticRenderFns } from "./TaskFocusModal.vue?vue&type=template&id=39d8c4f6&scoped=true&"
import script from "./TaskFocusModal.vue?vue&type=script&lang=js&"
export * from "./TaskFocusModal.vue?vue&type=script&lang=js&"
import style0 from "./TaskFocusModal.vue?vue&type=style&index=0&id=39d8c4f6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "39d8c4f6",
  null
  
)

export default component.exports